import { render } from "./IconDownload.vue?vue&type=template&id=6ed08aa4"
const script = {}
script.render = render

export default script